/**
 * Centralized API configuration for the admin portal.
 * Reads base URLs and keys from environment variables.
 */

const DEFAULT_LEAK_DETECTION_URL =
  "https://flatreading-and-cameranotsending-function.azurewebsites.net/api/leakdetectionfunction";
const DEFAULT_CAMERA_API_URL =
  "https://flatreading-and-cameranotsending-function.azurewebsites.net/api/camera-not-sending/";

export const adminApiConfig = {
  leakDetectionBaseUrl:
    import.meta.env.VITE_ADMIN_API_URL ?? DEFAULT_LEAK_DETECTION_URL,
  apiCode: import.meta.env.VITE_API_CODE ?? "",
  cameraApiBaseUrl:
    import.meta.env.VITE_CAMERA_API_URL ?? DEFAULT_CAMERA_API_URL,
  cameraApiCode: import.meta.env.VITE_API_CODE_CAMERA ?? "",
};

/**
 * Build the flat readings API URL for the given date range.
 */
export const getFlatReadingsUrl = (startDate, endDate) => {
  const { leakDetectionBaseUrl, apiCode } = adminApiConfig;
  const start = typeof startDate === "string" ? startDate : startDate?.toISOString?.() ?? "";
  const end = typeof endDate === "string" ? endDate : endDate?.toISOString?.() ?? "";
  return `${leakDetectionBaseUrl}?code=${apiCode}&startDate=${start}&endDate=${end}`;
};

/**
 * Build the real-time (ReadingsTail) API URL.
 */
export const getRealTimeUrl = () => {
  const { leakDetectionBaseUrl, apiCode } = adminApiConfig;
  return `${leakDetectionBaseUrl}?code=${apiCode}&table=ReadingsTail`;
};

/**
 * Build the camera-not-sending API URL.
 */
export const getCameraNotSendingUrl = () => {
  const { cameraApiBaseUrl, cameraApiCode } = adminApiConfig;
  return `${cameraApiBaseUrl}?code=${cameraApiCode}`;
};

/**
 * Get the camera API key for headers (e.g. x-functions-key).
 */
export const getCameraApiCode = () => adminApiConfig.cameraApiCode;
